import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SimplifiedCompany } from '../models/SimplifiedCompany';
import { CompanyService } from '../services/company.service';
import Swal from 'sweetalert2';
import { PlaceActionsComponent } from '../common/place-actions/place-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { WizardService } from '../../../shared/service/wizard.service';
import { PlaceFilterForm } from '../../operator/models/PlaceFilterForm';
import { Page } from 'src/app/shared/model/page';
import { Place } from '../../account/models/Place';
import { NetworkContractFilterForm } from '../../operator/models/NetworkContractFilterForm';
import { RequestFilterForm } from '../../operator/models/RequestFilterForm';
import * as moment from 'moment';
import {catchError, tap} from "rxjs/operators";
import {Observable, throwError} from "rxjs";
import {
  ModalContractCancelComponent
} from "../../../shared/components/modal-contract-cancel/modal-contract-cancel.component";
import {FinalClientService} from "../../account/services/final-client.service";

@Component({
  selector: 'app-company-gas-consumption-place',
  templateUrl: './company-gas.component.html',
  styleUrls: ['./company-gas.component.scss']
})
export class CompanyGasComponent implements OnInit {

  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

  public contractSettings = {
    actions: {
      custom: [
        {
          name: 'supplierChange',
          title: '<p class="actionSF" >Schimba furnizor</p>'
        },
        {
          name: 'sendIndex',
          title: '<p class="actionTI">Trimitere index</p>'
        },
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'recall',
          title: '<p class="actionR">Renunta</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionS">Anuleaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status == 'ACTIV') {
        const today = moment().startOf('day');
        const startingDate = row.data.startingDate && moment(row.data.startingDate);
        const indexDate = row.data.indexDate && moment(row.data.indexDate);
        if (
          startingDate && today.diff(startingDate, 'days') === 0 &&
          indexDate && indexDate.diff(startingDate, 'days') < 0
        ) {
          _class += 'row_c_activTI ';
        } else {
          _class += 'row_c_activ ';
        }
        if (row.data.placeStatus === 'DEZAFECTAT') {
          _class += 'row_dezafectat ';
        }
      } else if (row.data.status == 'INCETAT') {
        _class += 'row_c_incetat';
      } else if (row.data.status == 'SUSPENDAT') {
        _class += 'row_c_suspendat';
      } else if (row.data.status == 'ACTIV (in curs de schimbare)') {
        _class += 'row_c_activS';
      } else if (row.data.status == 'ACTIV (neintrat in vigoare)') {
        _class += 'row_c_activNV';
      } else {
        _class += 'xxxxx';
      }
      return _class;
    },
    hideSubHeader: true,
    columns: {
      placeCode: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      number: {
        title: 'Numar'
      },
      startingDate: {
        title: 'Data contract'
      },
      operator: {
        title: 'Operator loc consum'
      },
      supplierName: {
        title: 'Furnizor'
      },
      contractType: {
        title: 'Tip contract'
      },
      expirationDate: {
        title: 'Valabil pana la',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      }
    },
  };
  public onCustomActionContracts(event: any): void {
    switch (event.action) {
      case 'supplierChange':
        // this.errorNotification('Momentan indisponibil.');
        this.searchActiveRequestsByPlaceId(event.data.placeId, this.selectedCompany.code).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements > 0) {
              this.errorNotification('Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.');
            } else {
              this.wizardService.setWizardInformation({
                comparatorType: 'gas',
                editable: 'true',
                clientTypePJ: 'true',
                clientId: String(this.selectedCompany.clientId),
                contractNumber: String(event.data.number),
                placeId: String(event.data.placeId),
                supplierId: String(event.data.supplierId),
                supplierLicence: String(event.data.supplierLicence)
              });

              this.router.navigate(
                ['/utilizator/comparator'],
                {
                  queryParams: {
                    comparatorType: 'gas',
                    editable: 'true',
                    contractNumber: String(event.data.number),
                    placeId: String(event.data.placeId),
                    clientId: String(this.selectedCompany.clientId),
                    clientTypePJ: 'true'
                  }
                }
              );
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();
        break;
      case 'additionalAct':
        break;
      case 'recall':
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: '<span>Încetarea contractului de furnizare pentru alte motive decât schimbarea furnizorului se realizează prin intermediul furnizorului dumneavoastră. Contactați furnizorul în afara POSF pentru asistență în privința încetării contractului de furnizare.</span><br><span>*În situația în care aveți încheiat un contract de distribuție direct cu operatorul de distribuție este necesar să contactați direct operatorul de distribuție pentru încetarea lui.</span>',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
          customClass: {
            popup: 'popup-z-elevate-24-blue'
          }
        });

        /*Swal.fire({
          html: 'Esti sigur ca vrei sa renunti la acest contract?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
           customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
        }).then(result => {
          if (result.value) {
            this.companyService.cancelContract(event.data.id).subscribe(() => {
              this.searchContracts();
            });
          }
        });*/
        break;
      case 'sendIndex':
        this.router.navigate(['index'], {
          relativeTo: this.route, state: {
            placeCode: event.data.placeCode,
            contractId: event.data.id,
            contractNumber: event.data.number
          }
        });
        break;
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          editable: 'false',
          clientTypePJ: 'true',
          wizard: JSON.stringify(event.data.wizard),
          contractNumber: String(event.data.number),
          placeId: String(event.data.placeId),
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  public consumptionPlaceSettings = {
    actions: false,
    rowClassFunction: (row) => {
      let _class = '';
      if (row.data.status === 'DEZAFECTAT') {
        _class += 'row_dezafectat ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      status: {
        title: 'Status'
      },
      optiuni: {
        title: 'Optiuni',
        type: 'custom',
        renderComponent: PlaceActionsComponent,
        valuePrepareFunction: (rowData, cell, value) => {
          return {
            company: this.selectedCompany,
            data: rowData,
            cell
          };
        },
        onComponentInitFunction: (instance) => {
          instance.viewDetails.subscribe(row => {
            console.log('viewDetails: ', row);
            this.router.navigate(['loc-consum'], { relativeTo: this.route, state: { placeId: row.id, editable: false } });
          });
          instance.addNewContract.subscribe(row => {
            console.log('addNewContract: ', row);
            this.searchActiveRequestsByPlaceId(row.id, this.selectedCompany.code).pipe(
              tap((val: Page<any>) => {
                if (val.totalElements > 0) {
                  this.errorNotificationHtml('<span>Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.</span>');
                } else {
                  this.searchActiveContractsByPlaceId(row.id, this.selectedCompany.code).pipe(
                    tap((val: Page<any>) => {
                      if (val.totalElements > 0) {
                        this.errorNotificationHtml('<span>Atenție! Pe acest loc de consum există contract de furnizare activ.</span><br>' +
                          '<span>Dacă doriți să realizați schimbarea furnizorului, accesați tab-ul Contracte, identificați contractul pe care doriți să-l schimbați și selectați din dreptul acestuia opțiunea “Schimbă furnizor”.</span>');
                      } else {
                        this.wizardService.setWizardInformation({
                          comparatorType: 'gas',
                          editable: 'true',
                          clientTypePJ: 'true',
                          placeId: String(row.id),
                          clientId: String(this.selectedCompany.clientId),
                        });
                        this.router.navigate(
                          ['/utilizator/comparator'],
                          {
                            queryParams: {
                              comparatorType: 'gas',
                              editable: 'true',
                              placeId: String(row.id),
                              clientId: String(this.selectedCompany.clientId),
                              clientTypePJ: 'true'
                            }
                          }
                        );
                      }
                    }),
                    catchError((error) => {
                      this.errorNotification('Nu s-a putut verifica existenta contractelor active pe locul de consum selectat.');
                      return throwError(error);
                    })
                  ).subscribe();
                }
              }),
              catchError((error) => {
                this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
                return throwError(error);
              })
            ).subscribe();
          });
          instance.viewExistingContracts.subscribe(row => {
            console.log('addNewContract: ', row);
            this.companyService.getCompanyGasContracts(this.form.value['companies'], row.id).subscribe((val) => {
              this.gasContracts = val;
            });
            this.tabset.select('contracts');
          });
          instance.disassociateConsumptionPlace.subscribe(row => {
            console.log('disassociateConsumptionPlace', row);
            this.companyService.disassociateCompanyGasConsumptionPlace(row.code, this.form.value['companies']).subscribe((val) => {
              this.searchPlaces();
              this.searchContracts();
              this.searchRequests();
              this.successDisassociationNotification();
            }, error => {
              if (error) {
                this.errorNotification(error.error.message);
              }
            });
          });
        }
      }
    },
  };

  public requestSettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionA">Anuleaza</p>'
        },
        {
          name: 'complete',
          title: '<p class="actionR">Recompleteaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status === 'Informatii suplimentare') {
        _class += 'row_more_info ';
      } else if (row.data.status === 'Anulata' || row.data.status === 'Finalizata') {
        _class += 'row_finished ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    columns: {
      id: {
        title: 'Numar cerere'
      },
      placeCode: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      contractNumber: {
        title: 'Numar contract'
      },
      startingDate: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      operator: {
        title: 'Operator loc consum'
      },
      supplier: {
        title: 'Furnizor'
      },
      date: {
        title: 'Data transmitere',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      }
    },
  };

  form: FormGroup;

  public clcValue: string = '';
  public gasConsumptionPlaces: Page<Place>;
  public gasContracts: Page<any>;
  public gasRequests: Page<any>;
  public companiesConsumptionPlaces: SimplifiedCompany[] = [];
  public companiesContracts: SimplifiedCompany[] = [];
  public selectedCompany: SimplifiedCompany;
  public placeFilterForm: PlaceFilterForm = new PlaceFilterForm();
  public gasContractFilterForm: NetworkContractFilterForm = new NetworkContractFilterForm();
  public gasRequestFilterForm: RequestFilterForm = new RequestFilterForm();
  public paginationGasConsumptionPlaces = [];
  public paginationGasContracts = [];
  public paginationGasRequests = [];
  private consumptionPlaceError = 'Va rugam sa va asigurati ca ati introdus POD/CLC corect. Daca este corect introdus, este posibil ca locul de consum pe care incercati sa il asociati sa nu fie inca introdus in platforma de catre Operatorul de retea. Va rugam sa sesizati aceasta situatie catre Furnizorul cu care aveti contract de furnizare.';

  @ViewChild(NgbTabset, { static: false }) tabset: NgbTabset;

  constructor(
    private formBuilder: FormBuilder,
    private companyService: CompanyService,
    private finalClientService: FinalClientService,
    private wizardService: WizardService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.form = this.formBuilder.group({
      companies: ['']
    });
  }

  ngOnInit(): void {
    this.companyService.getSimplifiedUserOwnedCompanyList().subscribe((val: SimplifiedCompany[]) => {
      this.companiesConsumptionPlaces = val;
      this.companiesContracts = val;
    });
  }

  onCustomActionRequests(event: any): void {
    switch (event.action) {
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          clientTypePJ: 'true',
          editable: 'false',
          wizard: JSON.stringify(event.data.wizard),
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments),
          requestObservations: String(event.data.requestReason),
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: 'Esti sigur ca vrei sa renunti la aceasta cerere?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
           customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
        }).then(result => {
          if (result.value) {
            this.openCancelModal();
            this.companyService.cancelRequest(event.data.id).subscribe(async () => {
              this.searchRequests();
              const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
              await sleep(5000);
              Swal.close();
            });
          }
        });
        break;
      case 'complete':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          clientTypePJ: 'true',
          editable: 'true',
          requestId: String(event.data.id),
          wizard: JSON.stringify(event.data.wizard),
          clientId: String(this.selectedCompany.clientId),
          requestObservations: String(event.data.requestReason),
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  onCompanyChange(event: any): void {
    if (this.form.value['companies'] === '' !== null) {
      this.selectedCompany = this.companiesConsumptionPlaces.find(e => e.code === this.form.value.companies);
      this.searchPlaces();
      this.searchContracts();
      this.searchRequests();
    }
  }

  searchRequests(): void {
    this.companyService.getCompanyGasRequests(this.gasRequestFilterForm, this.form.value['companies']).subscribe((val) => {
      this.gasRequests = val;
      this.gasRequestFilterForm.pageOffset = val.number;
      this.paginationGasRequests = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasRequests.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasRequests[this.gasRequestFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changeRequestPage(page: any): void {
    this.gasRequestFilterForm.pageOffset = page.pageNumber;
    this.searchRequests();
  }

  previousRequestPage(): void {
    this.gasRequestFilterForm.pageOffset = this.gasRequestFilterForm.pageOffset === 0 ? 0 : this.gasRequestFilterForm.pageOffset - 1;
    this.searchRequests();
  }

  nextRequestPage(): void {
    this.gasRequestFilterForm.pageOffset = this.gasRequestFilterForm.pageOffset === this.gasRequests.totalPages - 1
      ? this.gasRequestFilterForm.pageOffset : this.gasRequestFilterForm.pageOffset + 1;
    this.searchRequests();
  }

  searchContracts(): void {
    this.companyService.getCompanyGasContracts(this.gasContractFilterForm, this.form.value['companies']).subscribe((val) => {
      this.gasContracts = val;
      this.gasContractFilterForm.pageOffset = val.number;
      this.paginationGasContracts = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasContracts.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasContracts[this.gasContractFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changeContractPage(page: any): void {
    this.gasContractFilterForm.pageOffset = page.pageNumber;
    this.searchContracts();
  }

  previousContractPage(): void {
    this.gasContractFilterForm.pageOffset = this.gasContractFilterForm.pageOffset === 0 ? 0 : this.gasContractFilterForm.pageOffset - 1;
    this.searchContracts();
  }

  nextContractPage(): void {
    this.gasContractFilterForm.pageOffset = this.gasContractFilterForm.pageOffset === this.gasContracts.totalPages - 1
      ? this.gasContractFilterForm.pageOffset : this.gasContractFilterForm.pageOffset + 1;
    this.searchContracts();
  }

  searchPlaces(): void {
    this.companyService.getCompanyGasConsumptionPlaces(this.form.value['companies'], this.placeFilterForm).subscribe((val) => {
      this.gasConsumptionPlaces = val;
      this.placeFilterForm.pageOffset = val.number;
      this.paginationGasConsumptionPlaces = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasConsumptionPlaces.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasConsumptionPlaces[this.placeFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changePage(page: any): void {
    this.placeFilterForm.pageOffset = page.pageNumber;
    this.searchPlaces();
  }

  previousPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === 0 ? 0 : this.placeFilterForm.pageOffset - 1;
    this.searchPlaces();
  }

  nextPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === this.gasConsumptionPlaces.totalPages - 1
      ? this.placeFilterForm.pageOffset : this.placeFilterForm.pageOffset + 1;
    this.searchPlaces();
  }

  associateConsumptionPlace(): void {
    if (this.clcValue === '' && this.form.value['companies'] === '') {
      this.errorNotification(this.consumptionPlaceError);
    } else if (this.clcValue === '') {
      this.errorNotification(this.consumptionPlaceError);
    } else if (this.form.value['companies'] === '') {
      this.errorNotification('Nicio companie selectata');
    } else {
      this.companyService.associateCompanyGasConsumptionPlace(this.clcValue, this.form.value['companies']).subscribe((val) => {
        this.searchPlaces();
        this.searchContracts();
        this.searchRequests();
        this.successAssociationNotification();
      }, error => {
        if (error) {
          this.errorNotification(error.error.message);
        }
      });
    }
  }

  isCompanyOwner(): boolean {
    return !this.selectedCompany ? false
      : this.selectedCompany.permissionsDTO.isOwner === true;
  }

  successAssociationNotification(): void {
    Swal.fire({
      title: ' ',
      text: 'Locul de consum ' + this.clcValue + ' a fost asociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  successDisassociationNotification(): void {
    Swal.fire({
      title: ' ',
      text: 'Locul de consum ' + this.clcValue + ' a fost dezasociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  searchActiveContractsByPlaceId(placeId, companyCode): Observable<Page<any>> {
    const filterForm = new NetworkContractFilterForm();
    filterForm.placeId = placeId;
    filterForm.companyCode = companyCode;
    filterForm.active = true;
    return this.finalClientService.getFCGasContracts(filterForm);
  }

  searchActiveRequestsByPlaceId(placeId, companyCode): Observable<Page<any>> {
    const filterForm = new RequestFilterForm();
    filterForm.placeId = placeId;
    filterForm.companyCode = companyCode;
    filterForm.active = true;
    return this.finalClientService.getFCGasRequests(filterForm);
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  errorNotificationHtml(message: string): void {
    Swal.fire({
      title: ' ',
      html: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  openCancelModal(): void {
    const modalHtml = this.getTemplateAsString();
    const swalInstance = Swal.fire({
      html: modalHtml,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  getTemplateAsString(): string {
    const componentRef = this.container.createComponent(ModalContractCancelComponent);
    const template = componentRef.location.nativeElement.innerHTML;
    // console.log(template); // Output the template as a string
    componentRef.destroy(); // Destroy the dynamically created component
    return template;
  }

}
